// extracted by mini-css-extract-plugin
export default {"history":"lsf-history","history__action":"lsf-history__action","history__action_delete":"lsf-history__action_delete"};
    if(module.hot) {
      // 1732531522937
      var cssReload = require("/home/kartik/kvr-lsf/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  